import { render, staticRenderFns } from "./tipoDocumentoSocioList.vue?vue&type=template&id=f33ae83a"
import script from "./tipoDocumentoSocioList.vue?vue&type=script&lang=js"
export * from "./tipoDocumentoSocioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports